"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogTransmitter = createLogTransmitter;
const core_fetch_1 = require("@telus/core-fetch");
const logBuffer = [];
const httpClient = new core_fetch_1.HttpClient();
let isCollectingLogs = false;
/**
 * Returns a log transmitter object that sends log messages to the specified endpoint. For client-side use only.
 * @param endpoint Endpoint to send log messages to
 * @param sendLogInterval Interval to send log messages
 * @returns Log transmitter object
 */
function createLogTransmitter(endpoint, sendLogInterval = 5000) {
    return {
        send: (_level, logEvent) => transmitLog(logEvent, endpoint, sendLogInterval)
    };
}
/**
 * Collects and transmits log messages to the specified endpoint at a set inerval. Default interval is 5 seconds.
 * @param logEvent Pino LogEvent
 * @param endpoint Endpoint to send log messages to
 * @param sendLogInterval Interval to send log messages
 */
function transmitLog(logEvent, endpoint, sendLogInterval) {
    logBuffer.push({
        messages: logEvent.messages,
        level: logEvent.level,
        ts: logEvent.ts
    });
    if (!isCollectingLogs) {
        isCollectingLogs = true;
        setTimeout(() => {
            sendLog(endpoint)
                .then(() => {
                isCollectingLogs = false;
            })
                .catch((error) => {
                console.error('Failed to send log message:', error);
            });
        }, sendLogInterval);
    }
}
/**
 * Sends log messages inside logBuffer to the specified endpoint
 * @param endpoint Endpoint to send messages to
 */
function sendLog(endpoint) {
    return __awaiter(this, void 0, void 0, function* () {
        const logLength = logBuffer.length;
        const logs = logBuffer.splice(0, logLength);
        try {
            yield httpClient.post(endpoint, {
                body: {
                    logs
                }
            });
        }
        catch (error) {
            console.error('Failed to send log message to the endpoint:', error);
        }
    });
}
exports.default = createLogTransmitter;
